'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var core_Icon_icons_default_Like = require('../Icon/icons/default/Like.js');
var core_Icon_icons_illustrations_Like = require('../Icon/icons/illustrations/Like.js');
var core_Card_Favorite_style = require('./Favorite.style.js');
var react = require('@emotion/react');
require('@babel/runtime/helpers/extends');
require('../../withIconProps-365ff8d5.js');
require('@babel/runtime/helpers/objectWithoutProperties');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('@styled-system/should-forward-prop');
require('styled-system');
require('@emotion/styled');

var renderFavoriteIcon = function renderFavoriteIcon(isFavorite) {
  return isFavorite ? react.jsx(core_Icon_icons_illustrations_Like["default"], {
    size: 16
  }) : react.jsx(core_Icon_icons_default_Like["default"], {
    size: 16
  });
};
var Favorite = function Favorite(_ref) {
  var favoriteAction = _ref.favoriteAction,
    _ref$isFavorite = _ref.isFavorite,
    isFavorite = _ref$isFavorite === void 0 ? false : _ref$isFavorite,
    size = _ref.size,
    _ref$renderFavorite = _ref.renderFavorite,
    renderFavorite = _ref$renderFavorite === void 0 ? renderFavoriteIcon : _ref$renderFavorite;
  return react.jsx(core_Card_Favorite_style.SFavorite, {
    size: size,
    onClick: favoriteAction,
    "data-testid": isFavorite ? 'adRemoveFromFavorites' : 'adAddToFavorites'
  }, renderFavorite(isFavorite));
};

exports.Favorite = Favorite;
//# sourceMappingURL=Favorite.js.map
